import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort, MatTableDataSource } from '@angular/material';
import { PhoneNumber } from '../../pricing-numbers';
import { SimpleChanges } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'cc-numbers-table',
  templateUrl: './numbers-table.component.html',
  styleUrls: ['./numbers-table.component.scss']
})
export class NumbersTableComponent implements OnInit, OnChanges {
  @ViewChild(MatSort) sort: MatSort;
  @Input() numbers: PhoneNumber[];
  @Output() refresh = new EventEmitter();
  @Output() chooseNumber = new EventEmitter<PhoneNumber>();

  public displayedColumns = ['number', 'action'];
  public dataSource: MatTableDataSource<PhoneNumber>;

  constructor() {}

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.numbers);
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.dataSource) {
      this.dataSource.data = this.numbers;
    }
  }

  onChooseNumber(phoneNumber: PhoneNumber) {
    this.chooseNumber.emit(phoneNumber);
  }

  onRefreshNumbers() {
    this.refresh.emit();
  }

  showRefreshNumbersButton(): boolean {
    return this.dataSource && this.dataSource.data && this.dataSource.data.length >= 10;
  }
}
